import * as Sentry from '@sentry/react';
import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';
import {
  createUserPat,
  CreatedUserPat,
  CreateUserPatProps,
} from '@/services/user/create-user-pat';

export const useCreateUserPat = (
  options?: Omit<
    UseMutationOptions<CreatedUserPat, Error, CreateUserPatProps, unknown>,
    'mutationFn'
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...options,
    mutationFn: createUserPat,
    onSuccess: (data, variables, context, mutation) => {
      queryClient.invalidateQueries({ queryKey: ['user-pats'] });
      options?.onSuccess?.(data, variables, context, mutation);
    },
    onError: (error, variables, context, mutation) => {
      Sentry.captureException(error, {
        extra: { context: 'create-user-pat' },
      });
      options?.onError?.(error, variables, context, mutation);
    },
  });
};
